export const SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select what the issue relates to',
  },
};

export const PRIVATE_PROPERTY_SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select if the issue is on private property',
  },
};

export const FLOODING_SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select where the flooding is affecting',
  },
};
